import { InfoInsights } from 'src/types/InfoInsights';
import axios from './axiosInstances/privateAxiosInstance';

const API_URL = '/qm/product/insights';
export type InfoInsightResponse = {
  sourceProductId?: InfoInsights[];
};
export const getInfoInsights = async (
  sourceOwnerId: string,
  sourceProductId: string,
  matchType: string,
  offset: number,
  size: number,
  regionId: string,
  priceType: string
): Promise<InfoInsightResponse> => {
  const res: InfoInsights[] = await axios.get(API_URL, {
    params: {
      matchType: matchType,
      regionId: regionId,
      priceType: priceType,
      sourceOwnerId: sourceOwnerId,
      sourceProductId: sourceProductId,
      offset: offset,
      size: size,
    },
  });
  return { [sourceProductId]: res };
};
